import styled from 'styled-components/macro';
import { white, grayVariant } from '../../styles/colors';
import { fontSize } from '../../styles/mixins';
import media from '../../styles/media';

export const FooterContainer = styled.footer`
  position: relative;
  justify-content: flex-start;
  align-items: initial;
  background-color: ${white};
  padding: 15px 15px 20px;
  display: flex;
  flex-direction: column;
  width: 100%;

  ${media.desktop`
    flex-direction: row;
    padding-left: 5%;
    padding-right: 5%;
    margin: 0 auto;
  `};

  article {
    :nth-child(3) {
      order: 2;
      margin-bottom: 9px;
    }
    :nth-child(2) {
      order: 3;
    }
    ${media.desktop`
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      margin-left: 35px;
      :nth-child(3) {
      order: 3;
    }
    :nth-child(2) {
      order: 2;
    }
    `};
    p {
      text-align: initial;
      color: ${grayVariant};
      ${fontSize(10)};

      ${media.desktop`
        ${fontSize(12)};
    `};
    }
    p:first-child {
      margin-bottom: 5px;
    }
  }
`;

export const FooterImage = styled.img`
  max-width: 70px;
  align-self: flex-start;
  margin-bottom: 15px;
  height: auto;
`;
